import React, { Suspense } from 'react'
import App from './App'
import { createRoot } from 'react-dom/client'
import axios from 'axios'
import './i18n'
import Loader from './components/Loader/Loader'
import 'bootstrap/dist/css/bootstrap.css'
import { StoreProvider } from './StoreProvider/ui/StoreProvider'

axios.defaults.baseURL = process.env.REACT_APP_API_URL

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Suspense fallback={<Loader />}>
    <StoreProvider>
      <App />
    </StoreProvider>
  </Suspense>
)
